import * as React from 'react';

import { Cell } from 'react-table';

import { ActionMenu } from '~shared/components/ActionMenu';
import { IconChevron } from '~shared/components/icons/micro';
import { WorkspaceMembersTableCell } from '~teacher/components/workspaces/WorkspaceMembers/WorkspaceMembersTable/WorkspaceMembersTableCell';

import {
  WorkspaceMember,
  WorkspaceRole,
} from '../../../../../api/workspaces/getWorkspaceMembers';

interface Props {
  cell: Cell<WorkspaceMember>;
  actions: any;
  row: any;
  canRemoveOthers: boolean;
  currentUserId: string;
  currentUserRole: WorkspaceRole;
}

const checkIsRowCurrentUser = ({
  rowUserId,
  currentUserId,
}: {
  rowUserId: string;
  currentUserId: string;
}) => rowUserId === currentUserId;

const checkIsCurrentUserOwner = (currentUserRole: WorkspaceRole) =>
  currentUserRole === WorkspaceRole.Owner;

const checkCanShowActionsMenu = ({
  currentUserId,
  rowUserId,
  canRemoveOthers,
  currentUserRole,
}: {
  currentUserId: string;
  rowUserId: string;
  canRemoveOthers: boolean;
  currentUserRole: WorkspaceRole;
}) => {
  const isRowCurrentUser = checkIsRowCurrentUser({
    rowUserId,
    currentUserId,
  });

  const isCurrentUserOwner = checkIsCurrentUserOwner(currentUserRole);

  if (isRowCurrentUser && isCurrentUserOwner) {
    return false;
  }

  if (isRowCurrentUser && !isCurrentUserOwner) {
    return true;
  }

  return canRemoveOthers;
};

export function WorkspaceMembersTableAccessMenu({
  actions,
  row,
  canRemoveOthers,
  cell,
  currentUserId,
  currentUserRole,
}: Props) {
  const canShowActionsMenu = checkCanShowActionsMenu({
    currentUserRole: currentUserRole,
    currentUserId: currentUserId,
    canRemoveOthers: canRemoveOthers,
    rowUserId: row.original.id,
  });

  return (
    <ActionMenu
      actions={actions}
      data={row.original}
      isDisabled={!canShowActionsMenu}
    >
      <WorkspaceMembersTableCell
        key={cell.getCellProps().key}
        column={cell.column}
      >
        <div className={'flex flex-row item-center justify-center gap-2'}>
          {cell.render('Cell')}
          {canShowActionsMenu ? <IconChevron direction={'down'} /> : <></>}
        </div>
      </WorkspaceMembersTableCell>
    </ActionMenu>
  );
}
